import InputField from "../../common_component/component/InputField";

const TotalCount = ({ displayData, handleChange, isView }) => {
  return (
    // <div className="cu-line-total-cont">
    //   <div>
    //     <div className="cu-line-total-div">
    //       <div className="cu-line-total">
    //         <spam className="cu-line-total-heading">Total</spam>
    //         <div className="cu-line-discount">
    //           <span>Discount</span>
    //           <input
    //             type="checkbox"
    //             checked={formData?.totalDiscType}
    //             onClick={(e) => handleChange(e.target.checked, "totalDiscType")}
    //           />
    //         </div>
    //         <div className="cu-line-total-discount-field">
    //           <div>
    //             <InputField
    //               type={"text"}
    //               placeholder={"select"}
    //               id={"total"}
    //               value={formData?.total}
    //               onChange={(e) => handleChange(e.target.value, "total")}
    //             />
    //           </div>
    //           <span>%</span>
    //         </div>
    //       </div>
    //     </div>
    //     <div className="cu-line-grand-total">
    //       <span>Grand Total</span>
    //       <span>{displayData?.grandTotal}</span>
    //     </div>
    //   </div>
    // </div>
    <div className="cu-grand-total-main">
      <div className="cu-total-disc-cont">
        <div className="cu-total-text">Total</div>
        <div className="cu-total-disc-checkbox">
          <label>Discount</label>
          <input
            type="checkbox"
            checked={displayData?.discount_type === "amount" ? false : true}
            onChange={() => {}}
            onClick={(e) =>
              handleChange(
                displayData?.discount_type === "amount"
                  ? "percentage"
                  : "amount",
                "discount_type"
              )
            }
            disabled={isView}
          />
        </div>
        <div className="cu-total-disc-input-cont">
          <div className="cu-total-disc-input">
            <InputField
              type={"number"}
              placeholder={"select"}
              id={"total"}
              value={displayData?.discount}
              onChange={(e) => handleChange(e.target.value, "discount")}
              disabled={isView}
            />
          </div>
          <div>%</div>
        </div>
      </div>
      <div className="cu-grand-total-cont">
        <div className="cu-grand-total-text">Grand Total</div>
        <div className="cu-grand-total-amt-text">
          {displayData?.invoice_total}
        </div>
      </div>
    </div>
  );
};

export default TotalCount;
